require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 677
// module chunks = 0